import { connect } from 'react-redux'
import { resetConfiguration } from '../../../configuration/actions'
import { setLayoutModalInfo, setLayoutVehiclePreview, setLayoutTradeInPreview } from '../actions'

import ModalDeleteInfo from './ModalDeleteInfo'

const mapStateToProps = state => ({
  modalInfos: state.layout.modalInfos,
  configuration: state.configuration
})

const mapDispatchToProps = {
  setLayoutModalInfo,
  setLayoutVehiclePreview,
  setLayoutTradeInPreview,
  resetConfiguration
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalDeleteInfo)
